export const formatCurrencyFromDecimal = (amount, decimalPlaces) => amount / 10 ** decimalPlaces;
export const formatCurrencyToDecimal = (amount, decimalPlaces) => amount * 10 ** decimalPlaces;
